// extracted by mini-css-extract-plugin
export var acceleratorButton = "Input-module__acceleratorButton___U16TK";
export var acceleratorIcon = "Input-module__acceleratorIcon___aeQsz";
export var basicBorderRadius = "Input-module__basicBorderRadius___BTdul";
export var disabled = "Input-module__disabled___4+J1k";
export var heroBorderRadius = "Input-module__heroBorderRadius___loWwV";
export var icon = "Input-module__icon___R+Sy2";
export var input = "Input-module__input___Y5z2m";
export var inputWrapper = "Input-module__inputWrapper___ZA+o6";
export var multilineAcceleratorButton = "Input-module__multilineAcceleratorButton___O32av";
export var multilineInput = "Input-module__multilineInput___gnoBU";
export var nonResizable = "Input-module__nonResizable___DplvL";
export var outerWrapper = "Input-module__outerWrapper___I2ni7";
export var singlelineInput = "Input-module__singlelineInput___klJkF";
export var singlelineInputWrapper = "Input-module__singlelineInputWrapper___kEt9b";